import React from "react";
import "./Dashboard.css";

function Logout () {
  return (
    <div>
      <button className="logout-button">LOG OUT</button>
    </div>
  )
};

export default Logout;